<template>
  <!-- 有下级，用el-sub-menu，无下级用el-menu-item -->
  <template v-for="item in menuList" :key="item.path">
    <!-- 非叶子节点 v-show：true(显示)false(隐藏)，v-if反之。 -->
    <el-sub-menu v-if="item.children?.length" :index="item.path">
      <template #title>
        <el-icon v-if="item.meta.icon && item.meta.icon.indexOf(SVG_PREFIX) == -1">
          <component :is="item.meta.icon"></component>
        </el-icon>
        <!-- 本地SVG -->
        <el-icon v-if="item.meta.icon && item.meta.icon.indexOf(SVG_PREFIX) == 0">
          <component :is="'SvgIcon'" :name="item.meta.icon"></component>
        </el-icon>
        <span v-text="item.meta.title"></span>
      </template>
      <HorizontalSubMenu :menu-list="item.children" />
    </el-sub-menu>
    <!-- 叶子节点（功能节点） -->
    <el-menu-item v-else :index="item.path" @click="handleMenuRouter(item)">
      <el-icon v-if="item.meta.icon && item.meta.icon.indexOf(SVG_PREFIX) == -1">
        <component :is="item.meta.icon"></component>
      </el-icon>
      <!-- 本地SVG -->
      <el-icon v-if="item.meta.icon && item.meta.icon.indexOf(SVG_PREFIX) == 0">
        <component :is="'SvgIcon'" :name="item.meta.icon"></component>
      </el-icon>
      <template #title>
        <span v-text="item.meta.title"></span>
      </template>
    </el-menu-item>
  </template>
</template>

<script setup lang="ts">
import HorizontalSubMenu from "@/layouts/components/Menu/HorizontalSubMenu.vue";
import { SVG_PREFIX } from "@/config/index";
import { lcMsgWarning } from "@/utils/util";
import { useRouter } from "vue-router";
import useTaskStore from "@/stores/modules/task";

type Props = {
  menuList: { [k: string]: any }[];
};

const router = useRouter();
// 获取父组件传递过来的数据
defineProps<Props>();

/* 打开标签页 或 外部链接 */
const handleMenuRouter = (value: any) => {
  if (value.meta?.isLink) {
    if (/^https?:\/\//.test(value.meta?.isLink)) {
      return window.open(value.meta.isLink, "_blank");
    } else {
      lcMsgWarning("非正确链接地址，禁止跳转");
      return;
    }
  }
  if (typeof value.meta?.formType !== "undefined" && value.meta?.formType) {
    const taskStore = useTaskStore();
    if (value.meta?.formType === 1) {
      taskStore.setSubtaskId(value.meta?.subtaskId);
      taskStore.setSubtaskWhereConfig(value.meta?.whereConfig);
      router.push({
        path: value.path,
        query: {
          id: value.meta?.subtaskId,
        },
      });
    } else if (value.meta?.formType === 2) {
      taskStore.setCollectionTaskId(value.meta?.collectionTaskId);
      taskStore.setSubtaskWhereConfig(value.meta?.whereConfig);
      router.push({
        path: value.path,
        query: {
          id: value.meta?.collectionTaskId,
        },
      });
    } else {
      router.push(value.path);
    }
    return;
  }
  if (value.meta?.subtaskId) {
    const taskStore = useTaskStore();
    taskStore.setSubtaskId(value.meta?.subtaskId);
    taskStore.setSubtaskWhereConfig(value.meta?.whereConfig);
    router.push({
      path: value.path,
      query: {
        id: value.meta?.subtaskId,
      },
    });
    return;
  }
  router.push(value.path);
};
</script>

<style lang="scss" scoped></style>
